import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { PosterCardComponent } from "../poster-card/poster-card.component";
import { Movie } from '../../services/Page/page.service';
import { CommonModule } from '@angular/common';
import { RoundArrowLeftComponent } from "../UI/round-arrow-left/round-arrow-left.component";
import { RoundArrowRightComponent } from "../UI/round-arrow-right/round-arrow-right.component";
import { gsap, Expo, Quad } from 'gsap';

@Component({
    selector: 'app-poster-list',
    imports: [
        CommonModule,
        SafeHtmlPipe,
        PosterCardComponent,
        RoundArrowLeftComponent,
        RoundArrowRightComponent
    ],
    templateUrl: './poster-list.component.html',
    styleUrl: './poster-list.component.scss'
})
export class PosterListComponent {
    @Input('title') title: string = ''
    
    private _movies: Movie[] = [];
    @Input('movies')
    public get movies(): Movie[] {
        return this._movies;
    }
    public set movies(value: Movie[]) {
        this._movies = value;

        if(this._movies.length > this.numberOnScreen) {
            this.nextEnabled = true
        }
    }

    @ViewChild('sliderHolder') sliderHolder: ElementRef | undefined
    @ViewChild('slider') slider: ElementRef | undefined
    @ViewChildren('elem') elem: QueryList<ElementRef> | undefined;


    currentIndex: number = 0
    numberOnScreen: number = 5
    prevEnabled: boolean = false
    nextEnabled: boolean = false


    gotoPosition(index: number) {
        if (index < 0) return
        if (index >= this.movies.length - this.numberOnScreen + 2) return

        let dir = -1
        if (this.currentIndex < index) {
            dir = 1
        }

        if(index == 0) {
            this.prevEnabled = false
        } else {
            this.prevEnabled = true
        }
        if(index >= this.movies.length - this.numberOnScreen + 1) {
            this.nextEnabled = false
        }
        else {
            this.nextEnabled = true
        }
        if(this.movies.length < this.numberOnScreen) {
            this.nextEnabled = false
        }



        let width = this.sliderHolder?.nativeElement.getBoundingClientRect().width / this.numberOnScreen

        let elements = Array.from(this.slider?.nativeElement.children)
        let prev = elements.slice(0, this.currentIndex)
        let visible = elements.slice(this.currentIndex, 6 + this.currentIndex)
        let next = elements.slice(this.currentIndex + 6, elements.length)

        if (this.currentIndex > index) {
            prev = elements.slice(0, this.currentIndex -1 )
            visible = elements.slice(this.currentIndex -1, 5 + this.currentIndex)
            next = elements.slice(this.currentIndex + 5, elements.length)
        }


        // gsap.to(elements, 1, { x: -1 * (width * index), stagger: dir * 0.015, ease: Expo.easeInOut })
        gsap.to(prev, 0.6, { x: -1 * (width * index), ease: Expo.easeInOut })
        gsap.to(visible, 0.6, { x: -1 * (width * index), stagger: dir * 0.03, ease: Expo.easeInOut })
        gsap.to(next, 0.6, { x: -1 * (width * index), ease: Expo.easeInOut })
        // this.elem?.forEach((elementRef: ElementRef) => {
        // });

        this.currentIndex = index
    }

    next() {
        this.gotoPosition(this.currentIndex + 1)
    }

    prev() {
        this.gotoPosition(this.currentIndex - 1)
    }


}
